module.exports = __webpack_public_path__ + "static/media/shopping-cart.d95bd02a.svg";